import { styled } from 'styled-components';
import { Modal } from '../Modal';

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    padding: 0 !important;
  }

  .ant-modal-header {
    padding: 16px 24px;
    margin: 0 !important;
    background-color: ${props => props.theme.colors.neutral.light.contentBg};
    color: ${props => props.theme.colors.secondary.main.text};
  }

  .ant-tabs-nav,
  .ant-form-item,
  .ant-divider {
    margin: 0;
  }

  .ant-tabs-tab {
    border-radius: unset !important;
    padding: 16px 24px;
    color: ${props => props.theme.colors.secondary.main.text};
  }

  .ant-tabs-tab-active {
    color: ${props => props.theme.colors.primary.main.text} !important;
    background-color: transparent !important;
  }
`;
